import React from 'react';
import './SetupGuide.css';

export const SetupGuide: React.FC = () => {
  return (
    <div className="setup-guide">
      <div className="setup-card">
        <div className="setup-header">
          <h1>🔧 Firebase Setup Required</h1>
          <p>Welcome to PropertyReporter Web Platform!</p>
        </div>

        <div className="setup-content">
          <div className="setup-step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3>Get Your Firebase Configuration</h3>
              <p>Visit the <a href="https://console.firebase.google.com/" target="_blank" rel="noopener noreferrer">Firebase Console</a> and:</p>
              <ul>
                <li>Select your PropertyReporter project (same as iOS app)</li>
                <li>Go to Project Settings (gear icon)</li>
                <li>Scroll down to "Your apps" section</li>
                <li>Click "Add app" → "Web" (if not already added)</li>
                <li>Copy the configuration values</li>
              </ul>
            </div>
          </div>

          <div className="setup-step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3>Configure Environment Variables</h3>
              <p>Edit the <code>.env</code> file in your project root:</p>
              <div className="code-block">
                <pre>{`REACT_APP_FIREBASE_API_KEY=your-api-key-here
REACT_APP_FIREBASE_AUTH_DOMAIN=your-project.firebaseapp.com
REACT_APP_FIREBASE_PROJECT_ID=your-project-id
REACT_APP_FIREBASE_STORAGE_BUCKET=your-project.appspot.com
REACT_APP_FIREBASE_MESSAGING_SENDER_ID=123456789
REACT_APP_FIREBASE_APP_ID=1:123456789:web:abcdef`}</pre>
              </div>
            </div>
          </div>

          <div className="setup-step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3>Enable Authentication</h3>
              <p>In Firebase Console:</p>
              <ul>
                <li>Go to Authentication → Sign-in method</li>
                <li>Enable "Email/Password" provider</li>
                <li>Add your domain to authorized domains</li>
              </ul>
            </div>
          </div>

          <div className="setup-step">
            <div className="step-number">4</div>
            <div className="step-content">
              <h3>Configure Firestore</h3>
              <p>Set up database rules for web access:</p>
              <div className="code-block">
                <pre>{`rules_version = '2';
service cloud.firestore {
  match /databases/{database}/documents {
    match /reports/{reportId} {
      allow read: if request.auth != null 
        && request.auth.uid == resource.data.userId;
    }
  }
}`}</pre>
              </div>
            </div>
          </div>

          <div className="setup-step">
            <div className="step-number">5</div>
            <div className="step-content">
              <h3>Restart Development Server</h3>
              <p>After updating the <code>.env</code> file:</p>
              <div className="code-block">
                <pre>npm start</pre>
              </div>
            </div>
          </div>
        </div>

        <div className="setup-footer">
          <div className="info-box">
            <h4>💡 Important Notes:</h4>
            <ul>
              <li>Use the <strong>same Firebase project</strong> as your iOS app</li>
              <li>This enables shared authentication and data access</li>
              <li>Never commit your <code>.env</code> file to version control</li>
              <li>Environment variables must start with <code>REACT_APP_</code></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
